module.exports = __webpack_public_path__ + "static/media/logo.f870d0db.png";